/*
 * @Description: 其他页面模块
 * @Author: Harry
 * @Date: 2020-12-28 13:48:01
 * @LastEditTime: 2020-12-29 15:12:55
 * @LastEditors: Harry
 */
import i18n from "@/locales";

export default [
  //首页
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue"),
    meta: {
      title: ''
    }
  },
  //用户邮箱绑定验证失败页面（用于邮箱里显示）
  {
    path: "/email-verify/fail",
    name: "email-verify-fail",
    component: () => import("@/views/email-verify/fail.vue"),
    meta: {
      showHeader: false,
      keepAlive: true
    }
  },
  //用于用户邮箱绑定验证成功页面（用于邮箱里显示）
  {
    path: "/email-verify/success",
    name: "email-verify-success",
    component: () => import("@/views/email-verify/success.vue"),
    meta: {
      showHeader: false,
      keepAlive: true
    }
  },
  //身份证信息验证
  {
    path: "/verify-idcard",
    name: "verify-idcard",
    component: () =>
      import("@/views/security-center/PasswordTradeReset/IDCardVerify.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("security_center.idcard_verify.nav_title")
    }
  },
  //手机号验证码验证
  {
    path: "/verify-message",
    name: "verify-message",
    component: () =>
      import("@/views/security-center/PasswordTradeReset/MessageVerify.vue"),
    meta: {
      showHeader: true,
      title: "短信验证"
    }
  },
  //用户激活
  {
    path: "/account-activation",
    name: "account-activation",
    component: () => import("@/views/AccountActivation.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("account_activation.nav_title")
    }
  },
  //公告
  {
    path: "/notice",
    name: "notice",
    component: () => import("@/views/notices/index.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("notice.pageTitle")
    }
  },
  // 行情服务 market-services
  {
    path: "/market-services",
    name: "market-services",
    component: () => import("@/views/market-services/index.vue"),
    meta: {
      showHeader: false,
      title: i18n.t("marketServices.t00001")
    }
  },
  //ws 测试页面
  {
    path: "/ws-test",
    name: "ws-test",
    component: () => import("@/views/WsTest.vue"),
    meta: {
      showHeader: false,
      title: "行情测试"
    }
  },
  {
    path: "/treemap",
    name: "treemap",
    component: () => import("@/views/treemap/index.vue"),
    meta: {
      showHeader: false,
      title: i18n.t("treemap.t3"),
      isH5Page: false
    }
  },
];
